const Outward = {

    // FIELDS
    "department": "Department",
    "location": "Location",
    "component": "Component",
    "equipment": "Equipment",
    "imcf_no": "IMCF No",
    "date": "Date",
    "quantity": "Quantity",
    "search": "Search",

    // PAGE HEADER
    "outward": "Outward",

    // ERROR

    // TABLE HEADER
    "table_department": 'DEPARTMENT',
    "table_location": 'LOCATION',
    "table_component": 'COMPONENT',
    "table_equipment": 'EQUIPMENT',
    "table_make": "MAKE",
    "table_new_part_number": "NEW PART NUMBER",
    "table_old_part_number": "OLD PART NUMBER",
    "table_km_item_code": "KM ITEM CODE",
    "table_imcf_no": 'IMCF NO',
    "table_date": "DATE",
    "table_quantity": "QUANTITY",

}

export default Outward;